import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { Plant } from '../models/plant.model';

@Injectable({ providedIn: 'root' })
export class PlantService {
  constructor(private apiService: ApiService) {}

  getAll(): Observable<Plant[]> {
    return this.apiService.get<Plant[]>('/Plant');
  }

  updateDescription(sapPlantId: number, description: string | null): Observable<Plant> {
    return this.apiService.put<Plant>(`/Plant/${sapPlantId}`, { Description: description });
  }
}
